<template>
  <button
    class="btn-download"
    @click="handleClick"
    :title="!canDownload ? upgradeMessage : 'Baixar CSV'"
    v-b-tooltip.hover.top
    v-b-tooltip.hover.v-success
  >
    <IconDownload />
    <span v-if="!loading">Download CSV</span>
    <span v-else>Gerando...</span>
  </button>
</template>

<script>
import { mapState } from "vuex";
import IconDownload from "@/components/icones/IconDownload.vue";

export default {
  name: "DownloadCsvButton",

  components: {
    IconDownload
  },

  props: {
    /**
     * Função que executa o download
     * Ex: () => this.downloadCSV()
     */
    onDownload: {
      type: Function,
      required: true,
    },

    /**
     * Mensagem custom de upgrade (opcional)
     */
    upgradeMessage: {
      type: String,
      default: "Faça upgrade para desbloquear" //  "Disponível a partir do plano Growth",
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      company: state => state.user.company,
    }),

    actualPlan() {
      return this.company?.actual_plan?.plan_details || null;
    },

    canDownload() {
      return Boolean(this.actualPlan?.can_export_csv);
    },
  },

  methods: {
    async handleClick() {
      if (!this.canDownload || this.loading) return;

      try {
        this.loading = true;
        await this.onDownload();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-download {
  background: #1f1f1f;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-download svg {
  height: 20px;
  width: 20px;
}

.btn-download:hover {
  background: #1f1f1f;
  opacity: .8;
}

.btn-download.disabled {
  background: #d1d5db;
  cursor: not-allowed;
  color: #6b7280;
}
</style>
